import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

// import ModalParcela from "./ModalParcela";
import { toast } from "react-toastify";
import Miniwidget from "./Miniwidget";

const DadosCliente = (props) => {
  const [modal, setModal] = useState(false);
  const cliente = props.cliente;

  const [nomeCompleto, setNomeCompleto] = useState("");
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [endereco, setEndereco] = useState("");

  useEffect(() => {
    setNomeCompleto(cliente.nome);
    setCpf(cliente.cpf);
    setEmail(cliente.email);
    setTelefone(cliente.telefone);
    setDataNascimento(cliente.data_nascimento);
    setEndereco(cliente.endereco);
  }, [cliente]);

  const reports = [
    {
      title: "Consultas",
      iconClass: "cube-outline",
      total: "1",
      average: "+11%",
      badgecolor: "info",
    },
    {
      title: "Total Consultas",
      iconClass: "buffer",
      total: "$46,782",
      average: "-29%",
      badgecolor: "danger",
    },
    {
      title: "Média por consulta",
      iconClass: "tag-text-outline",
      total: "$15.9",
      average: "0%",
      badgecolor: "warning",
    },
    {
      title: "Data última consulta",
      iconClass: "briefcase-check",
      total: "1890",
      average: "+89%",
      badgecolor: "info",
    },
  ];

  const { id } = useParams();

  const toggle = () => setModal(!modal);

  const formatarData = (data) => {
    const date = new Date(data);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const handleOnParcelaEdicao = (texto, type) => {
    if (type === "success") {
      toast.success(texto);
    } else {
      toast.error(texto);
    }
  };

  return (
    <>
      {/* <ModalParcela
        onParcelaEdicao={handleOnParcelaEdicao}
        ParcelaEditavel={parcelaEditavel}
        isOpen={modal}
        toggle={toggle}
      /> */}
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row>
                <Col md={12}>
                  <Miniwidget reports={reports} />
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="nomeCompleto">Nome Completo</Label>
                    <Input
                      type="text"
                      name="nomeCompleto"
                      id="nomeCompleto"
                      value={nomeCompleto}
                      onChange={(e) => setNomeCompleto(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="cpf">CPF</Label>
                    <Input
                      type="text"
                      name="cpf"
                      id="cpf"
                      value={cpf}
                      onChange={(e) => setCpf(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      type="text"
                      name="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="telefone">Telefone</Label>
                    <Input
                      type="text"
                      name="telefone"
                      id="telefone"
                      value={telefone}
                      onChange={(e) => setTelefone(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="dataNascimento">Data de Nascimento</Label>
                    <Input
                      type="text"
                      name="dataNascimento"
                      id="dataNascimento"
                      value={dataNascimento}
                      onChange={(e) => setDataNascimento(e.target.value)}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="endereco">Endereço</Label>
                    <Input
                      type="text"
                      name="endereco"
                      id="endereco"
                      value={endereco}
                      onChange={(e) => setEndereco(e.target.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DadosCliente;
